import * as React from "react";
import {} from "@blueprintjs/core";
import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import { useCommonHooks } from "../../hooks";
import { useGradeRef } from "../../hooks/applicationHooks/useGradeRef";

import { nameof } from "../../utils";
import { ReferentialItemDto } from "../../api";

export interface GradeSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    "requiredMark" | "visible" | "disabled" | "style" | "readonly"
  > {
  name: string;
  label?: string;
  loading?: boolean;
}

export const GradeSelect: React.FunctionComponent<GradeSelectProps> = ({
  name,
  label,
  loading = false,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { grades, gradesLoading } = useGradeRef();

  return (
    <FGSelectInput
      label={label || t("Grade")}
      name={name}
      items={grades}
      loading={gradesLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default GradeSelect;
